import { FEATURES } from '/src/features/_global/constants';

export const WEB_ANALYTICS_PERMISSIONS = {
  [FEATURES.WEB_ANALYTICS]: ({ capabilities }) => ({
    navigate: capabilities?.webAnalytics.permissions.nav,
    view: capabilities?.webAnalytics.permissions.view,
  }),
};
